class ApiConfig {

  static key = "!n$eyN7T5ch1nd1a95ffiD@t?@mF@rM#"; // 32 chars = AES-256
  static iv = "fn8eyf7!5ex1n41c"; // 16 chars = required IV length
  //static BASE_URL = "https://dev.indiametti.com/";
  static BASE_URL = "https://indiametti.com/";//prod
//  static BASE_URL = "https://localhost:7147/";
  //  static ENV = "DEV";
  static ENV = "PRD";

  static getUrl(path) {
    return `${this.BASE_URL}${path}`;
  }

  static base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  static arrayBufferToBase64(buffer) {
    const bytes = new Uint8Array(buffer);
    let binary = "";
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  static async encrypt(plainText) {
    if (!plainText) return "";

    const encoder = new TextEncoder();
    const data = encoder.encode(plainText);

    const keyBytes = encoder.encode(this.key);
    const ivBytes = encoder.encode(this.iv);

    const cryptoKey = await window.crypto.subtle.importKey(
      "raw",
      keyBytes,
      { name: "AES-CBC" },
      false,
      ["encrypt"]
    );

    const encryptedBuffer = await window.crypto.subtle.encrypt(
      {
        name: "AES-CBC",
        iv: ivBytes,
      },
      cryptoKey,
      data
    );

    return this.arrayBufferToBase64(encryptedBuffer);
  }

  static async decrypt(cipherText) {
    if (!cipherText) return "";

    const decoder = new TextDecoder();
    const encoder = new TextEncoder();

    const keyBytes = encoder.encode(this.key);
    const ivBytes = encoder.encode(this.iv);

    const encryptedData = this.base64ToArrayBuffer(cipherText);

    const cryptoKey = await window.crypto.subtle.importKey(
      "raw",
      keyBytes,
      { name: "AES-CBC" },
      false,
      ["decrypt"]
    );

    const decryptedBuffer = await window.crypto.subtle.decrypt(
      {
        name: "AES-CBC",
        iv: ivBytes,
      },
      cryptoKey,
      encryptedData
    );

    return decoder.decode(decryptedBuffer);
  }
}

export default ApiConfig;